import {
  DashboardIcon,
  PipelineIcon,
  PeopleIcon,
  AgentManagementIcon,
  AnalyticsIcon,
  ClosureIcon,
  SalesPipelineIcon
} from "../../../images/icons/icons";

export const closureTabList = [
  {
    id: "gym_sales_pipeline_dashboard",
    label: "gym_sales_pipeline_dashboard",
    icon: DashboardIcon,
  },
  {
    id: "pipeline_tracker",
    label: "pipeline_tracker",
    icon: PipelineIcon,
  },
  // {
  //   id: "gym_lead_management",
  //   label: "gym_lead_management",
  //   icon: PeopleIcon,
  // },
  {
    id: "agent_management",
    label: "agent_management",
    icon: AgentManagementIcon,
  },
  // {
  //   id: "analytics_&_reports",
  //   label: "analytics_&_reports",
  //   icon: AnalyticsIcon,
  // },
  // {
  //   id: "closure_tracking_&_detection",
  //   label: "closure_tracking_&_detection",
  //   icon: ClosureIcon,
  // },
];
